module.exports = require("vuetify/lib/components/VProgressCircular");